import { render, staticRenderFns } from "./Lang.vue?vue&type=template&id=375f99b2&scoped=true&"
import script from "./Lang.vue?vue&type=script&lang=ts&"
export * from "./Lang.vue?vue&type=script&lang=ts&"
import style0 from "./Lang.vue?vue&type=style&index=0&id=375f99b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375f99b2",
  null
  
)

export default component.exports